import * as React from "react";
import produce from "immer";
import { Dispatch, useReducer } from "react";
import { IProductModel } from "../../models";

const initialState = { copy: "jela", selectedProduct: undefined };
export const AppStateContext = React.createContext<
  IAppProviderState | undefined
>(initialState);
export const AppDispatchContext = React.createContext<
  Dispatch<any> | undefined
>(undefined);

const appReducer = produce((draft, action) => {
  switch (action.type) {
    case "INIT":
      draft.copy = "jela";
      break;
    case "SELECT_PRODUCT":
      draft.selectedProduct = action.value;
      break;
    case "CLEAR_SELECTION":
      draft.selectedProduct = null;
      break;
    default:
      throw new Error();
  }
});

interface IAppProviderState {
  copy: any;
  selectedProduct?: IProductModel;
}
const AppProvider: React.FC = props => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {props.children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
};

function useAppState() {
  const context = React.useContext(AppStateContext);

  if (context === undefined) {
    throw new Error("useAppState must be used within an AppProvider");
  }

  return context;
}

function useAppDispatch() {
  const context = React.useContext(AppDispatchContext);

  if (context === undefined) {
    throw new Error("useAppState must be used within an AppProvider");
  }

  return context;
}

export { AppProvider, useAppState, useAppDispatch };
